import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ATCONSTANTS as ATC } from 'appconstants';
import { getToken } from '@ctsu/loader';
import { COLUMNS } from './utils';

function RightSection({ rows, onDeleteRow }) {
  return (
    <div className="col-6">
      <GridTable
        id="StagedIndexing"
        rowEvents={[onDeleteRow]}
        tag={`${ATC.PACKETID}STAGED_INDEXING${ATC.TABLE}`}
        rows={rows}
        rowDeletable={() => true}
        title="Staged Indexing"
        columns={COLUMNS}
        recordPerPage={5}
        enableToolbar
        rowsPerPageOptions={[5, 15, 20]}
        highlightRow={0}
        toPdf={false}
        getToken={getToken}
      />
    </div>
  );
}

export default RightSection;
